<template>
	<div v-if="visible" class="channel-popup-mask"
		:style="{ zIndex: Math.floor(new Date().getTime() / 1000) - 1766396829 }">
		<div class="channel-popup-card">
			<div class="channel-popup-corner-block"></div>
			<div style="display: flex;justify-content: center;">
				<image src="../../assets/lives/laba.png" class="channel-popup-laba" mode="widthFix"></image>
			</div>
			<div class="channel-popup-title">通 知</div>
			<div class="channel-popup-content">
				<div v-if="displayText" class="channel-popup-text">{{ displayText }}</div>
				<img v-if="displayImage" :src="displayImage" class="channel-popup-image" alt="" />
			</div>
			<!-- <div class="channel-popup-btn" @click="close">知道了</div> -->
			<view style="text-align: center;">
				<image  style="width: 20px;" src="../../assets/lives/close.png" mode="widthFix" @click="close"></image>
			</view>
		</div>
	</div>
</template>

<script>
export default {
	name: "channelpopup",
	props: {
		popupData: {
			type: Object,
			default() {
				return {
					text: '',
					image: '',
				};
			},
		},
	},
	data() {
		return {
			visible: false,
			localPopupData: {
				text: '',
				image: '',
			},

		};
	},
	computed: {
		displayText() {
			return this.localPopupData.text || "";
		},
		displayImage() {
			return this.localPopupData.image || "";
		},
	},

	methods: {
		open(data) {
			this.localPopupData = data || this.popupData || {};
			this.visible = true;
		},
		close() {
			this.visible = false;
			this.$emit("close");
		},
	},
};
</script>

<style scoped lang="scss">
.channel-popup-mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	display: flex;
	align-items: center;
	justify-content: center;
}

.channel-popup-card {
	position: relative;
	width: 327px;
	background: #fff;
	border-radius: 18px;
	padding: 20px 16px 16px;
	box-sizing: border-box;
}

.channel-popup-corner-block {
	position: absolute;
	top: 18px;
	left: 42px;
	width: 54px;
	height: 33px;
	background: #fff0ee;
	box-shadow: 0 2px 99px 0 #ff3232;
	border-top-left-radius: 18px;
}

.channel-popup-title {
	text-align: center;
	font-size: 16px;
	font-weight: bold;
	color: #000;
}

.channel-popup-content {
	min-height: 160px;
	padding: 16px 10px 24px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
}

.channel-popup-text {
	font-size: 14px;
	color: #101010;
	line-height: 22px;
	word-break: break-all;
	margin-bottom: 12px;
	font-weight: 500;
}

.channel-popup-image {
	width: 180px;
	height: 180px;
	object-fit: contain;
}

.channel-popup-btn {
	height: 42px;
	line-height: 42px;
	text-align: center;
	background: #fbd586;
	color: #572e18;
	border-radius: 30px;
	font-size: 16px;
	font-weight: bold;
}

.channel-popup-laba {
	width: 87px;
	animation: laba-breath 1.8s ease-in-out infinite;
	transform-origin: center center;
}

@keyframes laba-breath {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.12);
	}
	100% {
		transform: scale(1);
	}
}
</style>
